<template>
   <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="900">
      <v-card>

         <CardUpdatableHeader :row="row" :level="level"/>

         <v-card-text>
            <v-container>
            <v-row>
               <v-col cols="12" sm="6">
                  <v-text-field v-model="row.prc_code" :disabled="level.dialogValues.form_disabled" outlined :label="$t('texts._required_code')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints._code')" persistent-hint>
                  </v-text-field>
               </v-col>
               <v-col cols="12" sm="6">
                  <v-text-field v-model="row.prc_internalcode" :disabled="!level.dialogValues.form_create" outlined :label="$t('texts.prc_internalcode')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints.prc_internalcode')" persistent-hint>
                  </v-text-field>
               </v-col>
            </v-row>
               <v-col>
                  <v-text-field v-model="row.prc_name" :disabled="level.dialogValues.form_disabled" :label="$t('texts.prc_name')" :hint="$t('hints.prc_name')"></v-text-field>
               </v-col>
            <v-row>
               <v-col>
                  <ddoSelect2
                     :callbacks="PRCcallbacks"
                     ref="mySelectPRC"
                     :options="PRCoptions"
                  >
                     <template v-slot:selection="data">
                        <v-chip
                           v-bind="data.attrs"
                           :input-value="data.selected"
                           close
                        >
                           <span>{{data.item.prc_code}}</span>
                        </v-chip>
                     </template>

                     <template v-slot:item="data">
                        <v-list-item-content>
                           <v-list-item-title>{{data.item.prc_name}}</v-list-item-title>
                           <v-list-item-subtitle v-html="data.item.prc_code"></v-list-item-subtitle>
                        </v-list-item-content>
                     </template>
                  </ddoSelect2>
                  <!--
                  <template>
                     <editor-content :editor="editor"/>
                  </template>
                  -->
               </v-col>
            </v-row>
            <h4>{{ $t('subtitles.settings') }}</h4>
            <v-row dense no-gutters>
               <v-col dense cols="12" sm="6">
                  <v-switch
                     dense
                     v-model="row.prc_active"
                     :label="$t('texts.prc_active')"
                     :disabled="level.dialogValues.form_delete"
                  >
                  </v-switch>
                  <v-switch
                     dense
                     v-model="row.prc_visible_on_front"
                     :label="$t('texts.prc_visible_on_front')"
                     :disabled="level.dialogValues.form_delete"
                  >
                  </v-switch>
                  <v-switch
                     dense
                     v-model="row.prc_for_logged_customer"
                     :label="$t('texts.prc_for_logged_customer')"
                     :disabled="level.dialogValues.form_delete"
                  >
                  </v-switch>
               </v-col>
               <v-col dense cols="12" sm="6">
                  <v-row>
                     <v-col dense cols="12" sm="4">
                        <v-text-field v-model="row.prc_level" :disabled="true" outlined :label="$t('texts._level')" persistent-hint>
                        </v-text-field>
                     </v-col>
                     <v-col dense cols="12" sm="4">
                        <v-text-field v-model="row.prc_order" :disabled="level.dialogValues.form_disabled" outlined type="number" :label="$t('texts._order')" required :hint="$t('hints._order')" persistent-hint>
                        </v-text-field>
                     </v-col>
                     <v-col dense cols="12" sm="4">
                        <v-text-field v-model="row.prc_orderpath" :disabled="true" outlined :label="$t('texts._orderpath')">
                        </v-text-field>
                     </v-col>
                  </v-row>
               </v-col>
            </v-row>
            <v-row>
               <v-col v-if="!level.dialogValues.form_create" cols="12">
                  <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.prc_create,'long') }}<br/>
                  <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.prc_create,'long') }}
               </v-col>
            </v-row>
         </v-container>
            <small>*{{ $t('texts.requiredfield') }}</small>
         </v-card-text>

         <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
   </v-dialog>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoSelect2 from '@/components/ddoSelect2.vue';
import { Editor, EditorContent } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';

export default {
   name: 'CardUpdatableProductCategory',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter,
      Editor, EditorContent,
      ddoSelect2,
   },

   props: {
   },

   data: function () {
      return {
         editor: null,

         PRCcallbacks: {},
         PRCoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "prc_code",
            item_value: "prc_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.productcategory'),
         },
      }
   },

   created() {
      this.PRCcallbacks.refresh_rows = this.build_select_prc;
      this.PRCcallbacks.change       = this.change_prc;
   },

   mounted() {
      /*
      this.editor = new Editor({
         extensions: [ StarterKit, ],
         content: '<p>Salut</p>',
      })
      */
   },

   beforeDestroy() {
      if ( this.editor!==null ) {
         this.editor.destroy()
      }
   },

   methods: {

      /*
       * Build Productcategory List, but only for different of current PRC
       */
      async build_select_prc(key=null) {
         console.log('build_select_prc')
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'productcategory');
         if ( api_response.error==0 ) {
            var restructured_rows = [];
            for ( var i=0;i<api_response.rows.length;i++ ) {
               if ( api_response.rows[i].prc_pk!=this.row.prc_pk ) {
                  restructured_rows.push(api_response.rows[i]);
               }
            }
            api_response.rows = restructured_rows;
         }
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change_prc(value,item=null) {
         if ( item!=null ) {
            this.row.prc_pk_parent = item;
         } else {
            this.row.prc_pk_parent = value;
         }
        console.log('change_prc, prc_pk_parent='+this.row.prc_pk_parent);
      },

   }
   
}
</script>

<style lang="scss" scoped>
::v-deep {
  /* Basic editor styles */
  .ProseMirror {
    > * + * {
      margin-top: 0.75em;
    }

    code {
      background-color: rgba(#616161, 0.1);
      color: #616161;
    }
  }

  .content {
    padding: 1rem 0 0;

    h3 {
      margin: 1rem 0 0.5rem;
    }

    pre {
      border-radius: 5px;
      color: #333;
    }

    code {
      display: block;
      white-space: pre-wrap;
      font-size: 0.8rem;
      padding: 0.75rem 1rem;
      background-color:#e9ecef;
      color: #495057;
    }
  }
}
</style>